const DMA = {
  GORNJIGRAD: { label: 'Gornji Grad', value: 0 },
  SREDNJIGRAD: { label: 'Srednji Grad', value: 1 },
  DONJIGRAD: { label: 'Donji Grad', value: 2 },
  CIRIS: { label: 'Čiriš', value: 3 },
  MEJDANIC: { label: 'Mejdanić', value: 4 },
  GORNJIRITASICI: { label: 'Gornji Ritašići', value: 5 },
  DONJIRITASICI: { label: 'Donji Ritašići', value: 6 },
  PRIBAVACENTAR: { label: 'Pribava Centar', value: 7 },
  PRIBAVAMERAJE: { label: 'Pribava Meraje', value: 8 },
  BPGDGLVSELH: { label: 'BP-GD-GL-V-SEL-H', value: 9 },
  NEPOZNATO: { label: 'Nepoznato', value: 10 },
};

export default DMA;
